<template>
  <PrescriptionResultPage :config="config" />
</template>

<script>
import PrescriptionResultPage from '@/components/smallComponents/PrescriptionResultPage.vue'

export default {
  components: { PrescriptionResultPage },
  data() {
    return {
      config: {
        pageTitle: '调理信息确认',
        showSymptoms: true,
        showGanZhiLabel: true,
        priceApi: '/api/health/v2/price',
        recordType: 'B',
        redirectRoute: '/chaoweiPrescription',
      },
    }
  },
}
</script>
<style scoped>
</style>
